import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import { useLocation } from "react-router-dom";
import QRCode from "qrcode";
import { useState, useEffect } from "react";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0'); // Adds leading zero if single digit
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Adds leading zero if single digit
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const styles = StyleSheet.create({
  page: {
    padding: "2 3",
    fontFamily: "Helvetica",
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
    justifyContent:"center"

  },
  container: {
    border: "1px",
    borderColor: "#000",
    width:"100%",
    padding: 3,
  },
  title: {
    textAlign: "center",
    fontSize: 10,
    fontWeight: "bold",
    margin: 2,
  },
  infoContainer: {
    flexDirection: "column",
    justifyContent: "space-between",
    height:"80%",
    rowGap:10
  },
  infoBox: {
    flex: 1,
    marginRight: 10,
    flexDirection: "row",
  },
  infoBoxLast: {
    border: "1px",
    borderColor: "#000",
    flex: 1,
  },
  label: {
    fontSize: 10,
    marginBottom: 4,
    color: "#666",
  },
  value: {
    fontSize: 10,
    fontWeight: "bold",
  },
  qrContainer: {
    border: "1px",
    borderColor: "#000",
    padding: 5,
    alignItems: "center",
    width: "45%",
  },
  qrCode: {
    width: 80,
    height: 80,
  },
  rowContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    height: "auto",
  },
});

const PDFContent = ({ data, packNo, qrCode, cardno }) => (
  <Document>
    <Page size="A8" orientation="landscape" style={styles.page}>
      {Array.from({ length: packNo }).map((_, index) => (
        <View key={index} style={styles.container}>
          <View style={styles.title}>
            <Text>PRECISION PRODUCTS</Text>
          </View>

          <View style={styles.rowContainer}>
            <View style={{ flex: 1, marginRight: 20 }}>
              <View style={styles.infoContainer}>
                <View style={styles.infoBox}>
                  <Text style={styles.label}>Card No:</Text>
                  <Text style={styles.value}>{cardno}</Text>
                </View>
                <View style={styles.infoBox}>
                  <Text style={styles.label}>Batch No:</Text>
                  <Text style={styles.value}>{data.lotNo}</Text>
                </View>
                <View style={styles.infoBox}>
                  <Text style={styles.label}>Date:</Text>
                  <Text style={styles.value}>{formatDate(data.date)}</Text>
                </View>

                <View style={styles.infoBox}>
                  <Text style={styles.label}>Pkg Qty:</Text>
                  <Text style={[styles.value, { marginLeft: 10 }]}>{data.packingQuantity} Pcs.</Text>
                </View>
                <View style={styles.infoBox}>
                  <Text style={styles.label}>Pkg Wt:</Text>
                  <Text style={[styles.value, { marginLeft: 10 }]}>{data.packingSize} Kg</Text>
                </View>

                
              </View>
            </View>

            {/* QR Code Box */}
            <View style={styles.qrContainer}>
              <Image style={styles.qrCode} source={{ uri: qrCode }} />
              <Text style={{ fontSize: 5, marginTop: 5 }}>
                Scan for details
              </Text>
            </View>
          </View>
        </View>
      ))}
    </Page>
  </Document>
);

const sampleData = {
  cardNo: "CARD-123",
  date: "2024-01-28",
  quantity: "500 pcs",
  weight: "250 kg",
  lotNo: "LOT-2024-001",
  pack: 3,
};

export default function PackagePDF() {
  const location = useLocation();
  const { data, vNo } = location.state || { data: sampleData }; // Provide default sampleData if no data is found

  const packnum = parseInt(data.pack);
  const vnum = parseInt(data.vNo);
  const cardnum = parseInt(data.cardNo);

  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");


  const url = `${window.location.origin}/fdipdf?lotno=${data.lotNo}&cardno=${cardnum}&mode=view`;

  useEffect(() => {
    QRCode.toDataURL(url, (err, qrCodeUrl) => {
      if (err) {
        console.error(err);
      } else {
        setQrCodeDataUrl(qrCodeUrl); // Set QR code URL once generated
      }
    });
  }, []); // Ensure QR code is generated once on component mount

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <PDFViewer width="100%" height="100%">
        <PDFContent
          data={data}
          packNo={packnum || 1}
          qrCode={qrCodeDataUrl}
          cardno={cardnum}
        />
      </PDFViewer>
    </div>
  );
}
